import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Layer } from 'office-ui-fabric-react/lib/Layer';
import { SxSLayerView } from 'owa-fileshub-sxs-layer-view';
import { HotkeysMap } from 'owa-hotkeys-map';
import { getCommandCategories, getCommands } from 'owa-mail-hotkeys';
import { ListPane } from 'owa-mail-list-pane-view';
import { listViewStore } from 'owa-mail-list-store';
import setListViewDimension from 'owa-mail-module-actions/lib/actions/setListViewDimension';
import ReadingPaneContainer from 'owa-mail-reading-pane-container/lib/components/ReadingPaneContainer';
import { lazyReloadReadingPane } from 'owa-mail-reading-pane-store';
import store from 'owa-mail-store/lib/store/Store';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { previewPaneStore } from 'owa-preview-pane-store';
import { lazyTriggerResizeEvent } from 'owa-resize-event';
import { ResizeHandle, ResizeHandleDirection } from 'owa-resize-handle';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { getStore as getTabStore, TabType } from 'owa-tab-store';
import { TabBar } from 'owa-tab-view';
import * as React from 'react';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { NotificationBarHost } from 'owa-notification-bar';
var classNames = require('classnames/bind');
var styles = require('./MailModule.scss');
var MailView = /** @class */ (function (_super) {
    tslib_1.__extends(MailView, _super);
    function MailView(props) {
        var _this = _super.call(this, props) || this;
        _this.onSxSClose = function () {
            // Reload the reading pane
            lazyReloadReadingPane.importAndExecute();
        };
        return _this;
    }
    MailView.prototype.render = function () {
        var _a = this.props, activeTab = _a.activeTab, isDumpsterOrDumpsterSearchTable = _a.isDumpsterOrDumpsterSearchTable, readingPanePosition = _a.readingPanePosition;
        var _b = this.props.listViewDimensions, listViewWidth = _b.listViewWidth, listViewHeight = _b.listViewHeight;
        var showSxSLayer = !!previewPaneStore.state && !!previewPaneStore.conversation;
        var isReadingPanePositionRight = readingPanePosition === ReadingPanePosition.Right;
        var isReadingPanePositionBottom = readingPanePosition === ReadingPanePosition.Bottom;
        // Set styles and classNames.
        var mailListStyle = {
            width: isReadingPanePositionRight ? listViewWidth : '',
            height: isReadingPanePositionBottom ? listViewHeight : '',
        };
        var showReadingPane = store.mailModule.showReadingPane;
        var showListPane = store.mailModule.showListPane;
        // Adjust list view & reading pane state for tab view
        var showTabBar = false;
        if (activeTab && !isDumpsterOrDumpsterSearchTable) {
            // Show tab bar when there is a secondary visible tab
            getTabStore().tabs.forEach(function (tab) {
                showTabBar = showTabBar || (tab.isShown && tab != activeTab);
            });
            // When reading pane is off, need to adjust reading pane/list view according to current tab type
            if (!isReadingPanePositionRight && !isReadingPanePositionBottom) {
                // When active tab is primary tab, show reading apne/list view according to the setting in mailStore
                // Otherwise, always show reading pane since reading pane is the container for all other tabs
                showReadingPane =
                    activeTab.type != TabType.Primary || store.mailModule.showReadingPane;
                showListPane = activeTab.type == TabType.Primary && store.mailModule.showListPane;
            }
        }
        var showTabBarInListView = showTabBar && showListPane && !showReadingPane && !isDumpsterOrDumpsterSearchTable;
        var showTabBarInReadingPane = showTabBar && !showTabBarInListView && !isDumpsterOrDumpsterSearchTable;
        var mailListClasses = classNames(isReadingPanePositionRight ? styles.mailList : styles.mailListSLV, !showListPane && styles.mailListHide, isReadingPanePositionBottom && styles.mailListBottomBorder);
        var subCommandBarPaneClasses = classNames(isReadingPanePositionBottom
            ? styles.subCommandBarPaneColumn
            : styles.subCommandBarPaneRow, styles.subCommandBarPaneCommon, styles.subCommandBarPaneMail);
        var showNotificationBar = (isMailFeatureEnabled('tri-notificationBar') ||
            isMailFeatureEnabled('cmp-delaySend')) &&
            !isReadingPanePositionRight;
        /**
         * KeyboardShortcutsMap requires an array of HotkeyCommands, so convert
         * the object from MailModuleHotKeys to an array.
         */
        var commandsObject = getCommands();
        var hotkeyCommands = Object.keys(commandsObject).map(function (key) { return commandsObject[key]; });
        return (React.createElement("div", { className: styles.rightPane },
            React.createElement("div", { className: subCommandBarPaneClasses },
                React.createElement(ListPane, { style: mailListStyle, className: mailListClasses, tableViewId: listViewStore.selectedTableViewId, tabBar: showTabBarInListView ? React.createElement(TabBar, null) : null }),
                showReadingPane &&
                    showListPane && (React.createElement(ResizeHandle, { direction: isReadingPanePositionBottom
                        ? ResizeHandleDirection.horizontal
                        : ResizeHandleDirection.vertical, onResize: this.onRightPaneResize })),
                showReadingPane && (React.createElement("div", { className: styles.readingPane },
                    React.createElement(ReadingPaneContainer, { showSxS: !!previewPaneStore.state && !previewPaneStore.conversation, isDumpsterOrDumpsterSearchTable: isDumpsterOrDumpsterSearchTable }),
                    showTabBarInReadingPane && React.createElement(TabBar, null))),
                showSxSLayer && this.renderCustomSxS(),
                showNotificationBar && React.createElement(NotificationBarHost, null)),
            React.createElement(HotkeysMap, { commandCategories: getCommandCategories(), goToOptions: function () {
                    lazyMountAndShowFullOptions.importAndExecute('general', 'configuration');
                }, hotkeyCommands: hotkeyCommands })));
    };
    MailView.prototype.renderCustomSxS = function () {
        return (React.createElement(Layer, null,
            React.createElement(SxSLayerView, { hideOwaHeader: true, onClose: this.onSxSClose })));
    };
    MailView.prototype.onRightPaneResize = function (listViewDimension, readingPaneDimension) {
        var userConfiguration = getUserConfiguration();
        var readingPanePosition = userConfiguration.UserOptions.GlobalReadingPanePositionReact;
        var isWidth = readingPanePosition == ReadingPanePosition.Right;
        setListViewDimension(listViewDimension, isWidth);
        lazyTriggerResizeEvent.importAndExecute();
    };
    MailView = tslib_1.__decorate([
        observer
    ], MailView);
    return MailView;
}(React.Component));
export default MailView;
//# sourceMappingURL=MailView.js.map